import { Outlet } from "react-router-dom";
import { useApp } from "./AppProvider";
import Loader from "./pages/Loader";
import Menu from "./Menu";

const App = () => {
  const { user } = useApp();
  if (!user) return <Loader></Loader>;

  return (
    <div className="h-full w-full flex">
      <div className="w-64 bg-white shadow-md">

        <div className="text-center p-5 border-b">
          <img src={user.pic} className="rounded-xl" width={200} />
          <div className="pt-3 font-semibold">{user.officialname}</div>
        </div>
        <Menu pages={user.pages}></Menu>
      </div>
      <div className="flex-1">
        <Outlet></Outlet>
      </div>
    </div>
  );
};

export default App;
